/**
 * Feature flags explicitly used by Payment SDK.
 */
export enum FeatureFlag {
  AllowCobadgedCards = 'feature.payment-processing.allow-cobadged-cards',
}
